type QueryObject = {
  [key: string]: string;
};

export function createQueryObj(searchParams: URLSearchParams) {
  const queryObj: QueryObject = {};
  searchParams.forEach((value, key) => {
    queryObj[key] = value;
  });

  return queryObj;
}
